/**
 * @generated SignedSource<<1b1a092be9a805cbb7bc9ab5403b64cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespStorytellingText_storyTellingTab$data = {
  readonly tabTitle: string;
  readonly contentHeader: string | null;
  readonly contentCreatorAttribution: {
    readonly creatorName: string;
    readonly creatorBrowseUrl: {
      readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
    };
  } | null;
  readonly contentBodyText: string;
  readonly tabType: string;
  readonly " $fragmentType": "PdpRespStorytellingText_storyTellingTab";
};
export type PdpRespStorytellingText_storyTellingTab$key = {
  readonly " $data"?: PdpRespStorytellingText_storyTellingTab$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespStorytellingText_storyTellingTab">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespStorytellingText_storyTellingTab",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tabTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentHeader",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoryTellingModuleCreator",
      "kind": "LinkedField",
      "name": "contentCreatorAttribution",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "creatorName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "creatorBrowseUrl",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SeoLink_linkData"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentBodyText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tabType",
      "storageKey": null
    }
  ],
  "type": "StoryTellingTab",
  "abstractKey": null
};

(node as any).hash = "50a63a8d7548625c473af72bb210664f";

export default node;
